import getItemId from "./helpers/getItemId";

const transformData = async (input, url, materialMasterfile, firmDetailsID) => {
  console.log("handleFileUpload transformData input : ", input);

  const localStorageData = JSON.parse(localStorage.getItem("User"));
  const userName = localStorageData?.userName || "NA";
  const tempTimeStamp = Math.round(new Date().getTime() + Math.random());

  return {
    projectName: input?.invoiceTo?.project_name || "NA",
    dueDate: "",
    id: tempTimeStamp,
    // id: input?.po_number ? input?.po_number : tempTimeStamp,
    invoiceURL: url,
    items: await Promise.all(
      input.items.map(async (extractedItem) => ({
        category: input?.invoiceTo?.project_name?.split("-")[1] || "NA",
        checked: false,
        description: `${extractedItem["Material/Service"]} ${extractedItem.Description}`,
        heading: `-`,
        itemDetails: {
          OrderId: `${new Date().getTime()}`,
          "Unit Name": "Malabar processed PO",
          UnitName: "Malabar processed PO",
          category: input?.invoiceTo?.project_name?.split("-")[1] || "NA",
          gst: "0",
          heading: "Malabar processed PO",
          indexces: {
            componentIndex: 0,
            materialIndex: 2,
            roomIndex: 5,
            unitIndex: 0,
          },
          item: "",
          milestones: [
            {
              name: "Completion",
              percentage: 100,
              totalAmount: "0.00",
            },
          ],
          orderStatus: "",
          quantity: String(Number(extractedItem.Qty)),
          rate: extractedItem.Rate || "0",
          roomName: "Malabar processed PO",
          specification: `${extractedItem["Material/Service"]} ${extractedItem.Description} ${extractedItem.HSN_SAC_code} ${extractedItem.CW_Qty}`,
          status: "",
          type: input?.invoiceTo?.project_name?.split("-")[1] || "NA",
          unit: extractedItem.Unit,
          workType: "Only Material",
        },
        itemID: null,
        // itemID: await getItemId(
        //   input?.invoiceTo?.project_name?.split("-")[1],
        //   `${extractedItem["Material/Service"]} ${extractedItem.Description}`,
        //   extractedItem.Unit,
        //   materialMasterfile,
        //   firmDetailsID
        // ),
        orderId: `${new Date().getTime()}`,
        quantity: String(Number(extractedItem.Qty)),
        remark: "",
        status: "Released",
        subHeding: "-",
        unit: extractedItem.Unit,
        // rate: extractedItem.Rate || "0",
        rate: "0",
        updatedAt: new Date().toISOString(),
        updatedBy: userName,
      }))
    ),
    requestHistory: {
      [tempTimeStamp]: {
        id: tempTimeStamp,
        name: userName,
        remark: "",
        status: "Released",
        quantities: input.items.map((item) => String(Number(item.Qty))) || [0],
      },
    },
    userName: userName,
    poNumber: input?.po_number || "notFound",
    versionNumber: input?.version_number?.split("-")[1] || "notFound",
  };
};

export default transformData;
